import { FlowStartComponent } from './start.component';

export default FlowStartComponent;
